/** Utah's words for taskguides.ts. */
export const TASKGUIDES_UT = {
  /** Event permit step: Salt Lake County wants the temporary food permit application at least one week ahead, with a late fee. */
  permitDeadlineStep: "Apply at least one week before the event (Salt Lake County). Later applications pay a late fee and may not be ready in time.",
  /** Person-in-charge step: at a Salt Lake County booth someone with a food handler card is always there. */
  boothCardStep: "At a Salt Lake County booth, someone with a food handler card is there at all times.",
  /** Cleared step: Utah's food handler permit timing (course within 14 days, permit within 30 days). */
  workerPermitStep: "Check each food worker has a Utah food handler permit, or finished the course within 14 days of starting and gets the permit within 30 days.",
} as const;
